import { NAME } from './constants';

export const SET_IS_CATALOGS_LOADING = `${NAME}/SET_IS_CATALOGS_LOADING`;

export const SET_CATALOGS_DATA = `${NAME}/SET_CATALOGS_DATA`;